import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const EmpleadosPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Empleados</PageTitle>
      <View />
    </>
  );
};

export { EmpleadosPage };
